import { Table } from 'antd'
import { useState } from 'react'
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons'

import { PaginationMeta } from 'models/pagination'
import { ActivityTracking } from 'models/activity-tracking'

import { ActivityTrackingColumns } from './ActivityTrackingColumns'

interface TenantActivityTrackingProps {
  loading: boolean
  activityTracking: ActivityTracking[]
  pagination: PaginationMeta
  onPaginationChange: (page: number) => void
}

const TenantActivityTrackingView: React.FC<TenantActivityTrackingProps> = ({
  loading,
  activityTracking,
  pagination,
  onPaginationChange,
}) => {
  const [expandableRowKeys, setExpandableRowKeys] = useState<{ [dataKey: number]: boolean }>({})

  const onExpand = (expanded: boolean, record: ActivityTracking) => {
    setExpandableRowKeys({ ...expandableRowKeys, [record.id]: expanded })
  }

  const rowExpandable = (record: ActivityTracking) => {
    if (Object.keys(expandableRowKeys).includes(`${record.id}`)) return true

    const rowElement = document.querySelector(`[data-row-key="${record.id}"]`)
    const currentRowHeight = (rowElement as HTMLElement)?.offsetHeight
    const childElements = rowElement?.querySelectorAll('.custom-row-collapse-tenant-activity-tracking > td > *')

    let expandable = false

    childElements?.forEach((el: Element) => {
      expandable = expandable || el.scrollHeight > currentRowHeight || (el.scrollHeight >= 63 && el.scrollHeight < 73)
    })

    return expandable
  }

  return (
    <Table
      sticky
      loading={loading}
      dataSource={activityTracking}
      rowKey={(record) => record.id}
      columns={ActivityTrackingColumns()}
      className="tenants-table"
      expandable={{
        onExpand,
        expandedRowRender: () => <></>,
        rowExpandable,
        expandIcon: ({ expandable, expanded, record, onExpand }) =>
          expandable ? (
            expanded ? (
              <MinusCircleOutlined onClick={(e) => onExpand(record, e)} />
            ) : (
              <PlusCircleOutlined onClick={(e) => onExpand(record, e)} />
            )
          ) : undefined,
      }}
      pagination={{
        hideOnSinglePage: true,
        position: ['bottomCenter'],
        total: pagination?.totalEntries,
        current: pagination?.currentPage,
        pageSize: pagination?.perPage,
        showSizeChanger: false,
        onChange: onPaginationChange,
      }}
      rowClassName={(record) => (expandableRowKeys[record.id] ? '' : 'custom-row-collapse-tenant-activity-tracking')}
    />
  )
}

export default TenantActivityTrackingView
